function collapseItem(
  theme: {
    palette: any;
    transitions: any;
    breakpoints: any;
    boxShadows: any;
    borders: any;
    functions: any;
  },
  ownerState: { active: any; transparentSidenav: any }
) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } =
    theme;
  const { active, transparentSidenav } = ownerState;

  const { dark, white, text, transparent } = palette;
  const { xxl } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    background: active && transparentSidenav ? white.main : transparent.main,
    color: active ? dark.main : text.main,
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `${pxToRem(10.8)} ${pxToRem(12.8)} ${pxToRem(10.8)} ${pxToRem(
      16
    )}`,
    margin: `0 ${pxToRem(16)}`,
    borderRadius: borderRadius.md,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: active && transparentSidenav ? xxl : "none",
    [breakpoints.up("xl")]: {
      boxShadow: () => {
        if (active) {
          return transparentSidenav ? xxl : "none";
        }

        return "none";
      },
      transition: transitions.create("box-shadow", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },
  };
}

function collapseIconBox(
  theme: {
    palette: any;
    transitions: any;
    breakpoints: any;
    boxShadows: any;
    borders: any;
    functions: any;
  },
  ownerState: { active: any; transparentSidenav: any; color: any }
) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } =
    theme;
  const { active, transparentSidenav, color } = ownerState;

  const { white, info, light, gradients } = palette;
  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  const backgroundValue = (() => {
    if (!active) return transparentSidenav ? white.main : light.main;
    if (color === "default" || !color) return gradients?.info?.main ?? info.main;
    if (color === "warning") return gradients?.warning?.main ?? palette.warning?.main;
    if (color === "info") return gradients?.info?.main ?? info.main;
    return palette[color]?.main ?? light.main;
  })();

  return {
    background: backgroundValue,
    minWidth: pxToRem(32),
    minHeight: pxToRem(32),
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    boxShadow: md,
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    [breakpoints.up("xl")]: {
      background: backgroundValue,
    },

    color: active ? white.main : gradients.dark.state,
    "& svg, svg g": {
      fill: "currentColor",
      stroke: "currentColor",
    },
  };
}

const collapseIcon = (theme: any, props: any) => ({
  color: props.active ? theme.palette.gradients.primary : theme.palette.white,
});

function collapseText(
  theme: {
    typography: any;
    transitions: any;
    breakpoints: any;
    functions: any;
  },
  ownerState: { miniSidenav: any; transparentSidenav: any; active: any }
) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(12.8),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft:
        miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(12.8),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: size.sm,
      lineHeight: 0,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
